import { pathConstants } from "./pathContants";

export const activityLogMap = {
  Supplier: {
    home: pathConstants.INVENTORY_SUPPLIERS,
    details: ({ id }) => pathConstants.INVENTORY_SUPPLIERS_DETAILS({ id }),
  },
  Order: {
    home: pathConstants.INVENTORY_SALES_TRANSACTIONS,
    details: ({ id }) => {
      return `${pathConstants.INVENTORY_SALES_TRANSACTIONS}?orderId=${id}`;
    },
  },
  Product: {
    home: pathConstants.INVENTORY_PRODUCTS,
    details: ({ id }) => pathConstants.INVENTORY_PRODUCT_EDIT({ id }),
  },
  Store: {
    home: pathConstants.INVENTORY_STORES,
    details: ({ id }) => pathConstants.INVENTORY_STORE_EDIT({ id }),
  },
  Expense: {
    home: pathConstants.EXPENSES_LIST(),
    details: ({ id }) => pathConstants.EXPENSES_DETAILS({ id }),
  },
  "Goods Received": {
    home: pathConstants.INVENTORY_GOODS_RECEIVED,
    details: ({ id }) => pathConstants.INVENTORY_GOODS_RECEIVED_DETAILS({ id }),
  },
  "Purchase Order": {
    home: pathConstants.INVENTORY_PURCHASE_ORDER,
    details: ({ id }) => pathConstants.INVENTORY_PURCHASE_ORDER_DETAILS({ id }),
  },
  Bills: {
    home: pathConstants.INVENTORY_BILLS,
    details: ({ id }) => pathConstants.INVENTORY_BILLS_DETAILS({ id }),
  },
  CUSTOMERS: {
    home: pathConstants.CUSTOMERS,
    details: ({ id }) => pathConstants.CUSTOMER_DETAILS({ customerId: id }),
  },
  "Stock Transfer": {
    home: pathConstants.INVENTORY_PRODUCT_BULK_TRANSFER_HISTORY,
    details: ({ id }) =>
      pathConstants.INVENTORY_STOCK_TRANSFER_DETAILS({ id: id }),
  },
  Returns: {
    home: pathConstants.INVENTORY_RETURNS,
    details: ({ id }) => pathConstants.INVENTORY_RETURNS,
  },
  Reconciliations: {
    home: pathConstants.INVENTORY_RECONCILIATIONS(),
    details: ({ id }) => pathConstants.INVENTORY_RECONCILIATIONS_REVIEW({ id }),
  },
  "Product Batch": {
    home: pathConstants.INVENTORY_PRODUCTS_BATCH,
    details: ({ id }) => pathConstants.INVENTORY_PRODUCTS_BATCH_EDIT({ id }),
  },
};
